import { render, staticRenderFns } from "./tab-map.vue?vue&type=template&id=ff596e2c&scoped=true"
import script from "./tab-map.vue?vue&type=script&lang=js"
export * from "./tab-map.vue?vue&type=script&lang=js"
import style0 from "./tab-map.vue?vue&type=style&index=0&id=ff596e2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff596e2c",
  null
  
)

export default component.exports